<template>
  <a-tooltip v-if="tooltipEnabled" :title="text">
    <div class="base-vxe-cell-tooltip-trigger" :class="alignClass">
      <div
        v-if="useEllipsis"
        class="base-vxe-cell-ellipsis"
        :style="clampStyle"
      >
        {{ text }}
      </div>
      <span v-else class="base-vxe-cell-text">
        {{ text }}
      </span>
    </div>
  </a-tooltip>
  <div v-else class="base-vxe-cell-tooltip-trigger" :class="alignClass">
    <div
      v-if="useEllipsis"
      class="base-vxe-cell-ellipsis"
      :style="clampStyle"
    >
      {{ text }}
    </div>
    <span v-else class="base-vxe-cell-text">
      {{ text }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'BaseVxeCellText',
})

const props = withDefaults(
  defineProps<{
    text: string
    /** 省略行数，0 表示不省略 */
    rows?: number
    align?: 'left' | 'center' | 'right'
    tooltip?: boolean
  }>(),
  {
    rows: 1,
    align: 'center',
    tooltip: true,
  }
)

const tooltipEnabled = computed(() => props.tooltip && Boolean(props.text))

const useEllipsis = computed(() => props.rows > 0)

const alignClass = computed(() => `is-align-${props.align}`)

const clampStyle = computed(() => ({
  WebkitLineClamp: props.rows,
}))
</script>

<style scoped lang="less">
.base-vxe-cell-tooltip-trigger {
  width: 100%;
  min-width: 0;
}

.base-vxe-cell-ellipsis {
  display: -webkit-box;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  word-break: break-word;
  line-height: 1.5714285714285714;
}

.base-vxe-cell-text {
  display: block;
  width: 100%;
  white-space: normal;
  word-break: break-word;
  line-height: 1.5714285714285714;
}

.is-align-left {
  text-align: left;
}

.is-align-center {
  text-align: center;
}

.is-align-right {
  text-align: right;
}
</style>
